import { render, staticRenderFns } from "./BenefitWorldClass.vue?vue&type=template&id=23739b92&"
import script from "./BenefitWorldClass.vue?vue&type=script&lang=js&"
export * from "./BenefitWorldClass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports